// @flow
import * as R from "ramda"

import type { PassengerFormObject } from "booking/services/reservation/types"
import getFormattedPaxBirthday from "./getFormattedPaxBirthday"

export default (pax: PassengerFormObject) => ({
  // $FlowFixMe: error revealed by updating Flow and Ramda libdef, please fix
  first_name: R.pathOr("", ["firstname", "value"], pax),
  // $FlowFixMe: error revealed by updating Flow and Ramda libdef, please fix
  middle_name: R.pathOr("", ["middlename", "value"], pax),
  // $FlowFixMe: error revealed by updating Flow and Ramda libdef, please fix
  last_name: R.pathOr("", ["lastname", "value"], pax),
  // $FlowFixMe: error revealed by updating Flow and Ramda libdef, please fix
  nationality: R.pathOr("", ["nationality", "value"], pax),
  birthday: getFormattedPaxBirthday(pax),
  language: "",
})
